import { getPhoneFramePortalElement } from '@web/components/phone-frame'
import { useWideDesktopLayout } from '@web/hooks/ui/use-wide-desktop-layout'
import { useMemo } from 'react'

// На wide desktop шит порталится в body: backdrop на весь viewport, контент — по центру экрана.
export function useSheetPortals() {
  const isWideDesktop = useWideDesktopLayout()
  const phoneFramePortal = getPhoneFramePortalElement()

  return useMemo(() => {
    const useBodyPortal = isWideDesktop && phoneFramePortal !== undefined

    return {
      portalContainer: useBodyPortal ? document.body : phoneFramePortal,
      useBodyPortal,
    }
  }, [isWideDesktop, phoneFramePortal])
}
